import { alertState } from "../components/AlertMe.vue"; // Adjust the path

export const Message = (type, message) => {
  alertState.type = type;
  alertState.message = message;
  alertState.show = true;

  // Automatically hide the alert after 3 seconds
  setTimeout(() => {
    alertState.show = false;
  }, 3000);
};
